import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import OrderItem from '../Order/OrderItem'
import UserSelect from '../AppHeader/UserSelect'

type Props = {}

const EditOrder = observer((props: Props) => {
  const open = RootStore.modalsUi.editOrder
  const order = RootStore.modalsUi.order

  const hundleClose = () => {
    RootStore.modalsUi.hundleEditOrder(false)
  }

  if (!order) return <></>

  const hundleChange = async () => {
    try {
      await RootStore.userAction.acceptOrder(order.id)
      toast.success(`Заказ принят`, {
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data

      toast.error(data?.message ?? 'Произошла ошибка', {
        ...toastConfig,
      })

      if (data.property) {
      }
    }
  }
  const hundleDelete = async () => {
    try {
      await RootStore.userAction.deleteIssue(order.id)
      toast.success(`Заказ удалён`, {
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data

      toast.error(data?.message ?? 'Произошла ошибка', {
        ...toastConfig,
      })

      if (data.property) {
      }
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose}>
      <DialogTitle>Принять заказ?</DialogTitle>
      <div>
        <DialogContent>
          <UserSelect filters={{ role: order.role?.value ?? '' }} />
          {order ? <OrderItem order={order} noAction /> : null}
        </DialogContent>
      </div>

      <DialogActions
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Button color="error" onClick={hundleDelete}>
          Отменить
        </Button>

        <div>
          <Button onClick={hundleChange}>Принять</Button>
          <Button onClick={hundleClose}>Отмена</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
})

export default EditOrder
